@if (!(_limitPersonalization | async)) {
  <div class="scenePicker">
    <div class="ctn">
      @for (option of setCounts$ | async; track option) {
        <span (click)="currentCount.patchValue(option)"
        [ngClass]="{isActive:option===currentCount.value}">{{option}}</span>
      }
    </div>
  </div>
}
<div class="piecesContainer">
  <div class="pieces">
    @for (scene of visibleScenes$
      | async; track scene) {
      <div (click)="pickedScene.emit(scene);currentScene=scene" [ngClass]="{active:(currentScene$ | async)?.wallDecorSceneForDisplayId===scene.wallDecorSceneForDisplayId}"
        class="scene"
        [id]="scene.wallDecorSceneForDisplayId"
        >
        <lib-wall-decor-icon
          [pieces]="scene.pieces"
        [price]="scene.pieces | calcWallDecorScenePrice:(config$ | async):rounding:preConfigValue:(usedImagesList$ | async):lookBookProductConfigId | async"></lib-wall-decor-icon>
      </div>
    }
  </div>
</div>
<div class="footer">

  <lib-button bare (click)="closed.next(undefined)">Powrót</lib-button>

  <lib-button (click)="save.emit()" *libIsHandset="desktop">
    @if (isUpdate) {
      Aktualizuj
    } @else {
      Dodaj do koszyka
      } &nbsp;@if (currentScene) {
      <span
      >{{currentScene.pieces | calcWallDecorScenePrice:(config$ | async):rounding:preConfigValue:(usedImagesList$ | async):lookBookProductConfigId | async}}</span>
    }
  </lib-button>
  <ng-template #desktop>
    <lib-button lg (click)="save.emit()">
      @if (isUpdate) {
        Aktualizuj
      } @else {
        Dodaj do koszyka
        } &nbsp;@if (currentScene) {
        <span
        >{{currentScene.pieces | calcWallDecorScenePrice:(config$ | async):rounding:preConfigValue:(usedImagesList$ | async):lookBookProductConfigId | async}}</span>
      }
    </lib-button>
  </ng-template>
</div>
